document.addEventListener('DOMContentLoaded', function() {
    //set header as half transparent and blur background
    const headerComp = document.getElementById('header-component');
    const headerRow = document.querySelectorAll('.header__row');
    const headerLogo = document.querySelectorAll('.header-logo');

    headerComp.style.display = 'none';
}, false);